import routePermissions from "./routePermissions/routePermissions";

/**
 * Simple tableau pour définir le menu en side panel, les titles sont définis dans le fichier locale; on inclut les permissions si nécessaire afin de controller l'affichage
 * @returns {*[]}
 */
export default function() {
  return [
    {
      title: "menu.general",
      items: [
        {
          title: "menu.notifications",
          to: {
            name: "my-notifications"
          },
          htmlBefore: '<i class="material-icons">&#xE917;</i>',
          htmlAfter: "notificationCount"
        }
        
        ,
        {
          title: "menu.ask",
          htmlBefore: '<i class="material-icons">note_add</i>',
          items: [
         
            {
              title: "menu.ask.days.off",
              to: {
                name: "days-off-request"
              }
            },
            {
              title: "menu.ask.minibus.request",
              to: {
                name: "minibus-request"
              }
            },
            {
              title: "menu.contract",
              to: {
                name: "contract-request"
              }
            },
            {
              title: "menu.regie",
              to: {
                name: "regie-request"
              }
            },
            {
              title: "menu.retour.regie",
              to: {
                name: "retour-regie-request"
              }
            },
            {
              title: "menu.ask.simple.absence",
              to: {
                name: "simple-absence-request"
              }
            },
            {
              title: "menu.ask.declare.hours",
              to: {
                name: "recovery-time-request"
              }
            },
            {
              title: "menu.ask.retrieve.hours",
              to: {
                name: "recovery-request"
              }
            },
            {
              title: "menu.ask.history",
              to: {
                name: "days-off-history"
              }
            }
          ]
        },
        {
          title: "menu.personalTasks",
          htmlBefore: '<i class="material-icons">format_list_bulleted</i>',
          to: {
            name: "personal-tasks"
          }
        },
        {
          title: "menu.dailyReport",
          htmlBefore: '<i class="material-icons">article</i>',
          to: {
            name: "dailyReportCalendar"
          }
        },
        {
          title: "menu.medicalLeave",
          htmlBefore: '<i class="material-icons">local_hospital</i>',
          permissions: routePermissions.medicalLeave,
          to: {
            name: "leave-by-accountant"
          }
        },
        {
          title: "menu.user.my",
          htmlBefore: '<i class="material-icons">&#xE7FD;</i>',
          to: {
            name: "user-profile"
          }
        }
      ]
    },
    {
      title: "menu.temporary.modules",
      items: [
        {
          title: "menu.user",
          htmlBefore: '<i class="material-icons">&#xE7FD;</i>',
          permissions: routePermissions["list-user"],
          items: [
            {
              title: "menu.user.list",
              to: {
                name: "list-users"
              },
              permissions: routePermissions["list-user"]
            },
            {
              title: "menu.user.add",
              to: {
                name: "add-user"
              },
              permissions: routePermissions["add-user"]
            }
          ]
        },
        {
          title: "menu.manageMinibuses",
          htmlBefore: '<i class="material-icons">directions_bus</i>',
          permissions: routePermissions["minibus-request-manage"],
          items: [
            {
              title: "menu.minibus.request.manager",
              permissions: routePermissions["minibus-request-manage"],
              to: {
                name: "minibus-request-manager"
              }
            },
            {
              title: "menu.minibus.planning",
              to: {
                name: "minibus-planning",
                params : {reference : "All"}
              },
              permissions: routePermissions["minibus-request-manage"]
            },
            {
              title: "menu.minibusManager",
              permissions: routePermissions["minibus-request-manage"],
              to: {
                name: "minibus-management"
              }
            }
          ]
        },
        {
          title: "menu.request.manager",
          htmlBefore: '<i class="material-icons">note_add</i>',
          permissions: routePermissions["leave-request-manager"],
          to: {
            name: "request-manager"
          }
        },
        {
          title: "menu.request.contract",
          htmlBefore: '<i class="fa fa-address-card" aria-hidden="true"></i>',
          permissions: routePermissions["contract-request-management"],
          to: {
            name: "contract-request-management"
          }
        },
        {
          title: "menu.request.regie",
          htmlBefore: '<i class="fa fa-credit-card" aria-hidden="true"></i>',
          permissions: routePermissions["regie-request-management"],
          to: {
            name: "regie-request-management"
          }
        },
        {
          title: "menu.request.retour.regie",
          htmlBefore: '<i class="fa fa-credit-card" aria-hidden="true"></i>',
          permissions: routePermissions["retour-regie-request-management"],
          to: {
            name: "retour-regie-request-management"
          }
        },
        {
          title: "menu.request.employee",
          htmlBefore: '<i class="fa fa-users" aria-hidden="true"></i>',
          permissions: routePermissions["employee-management"],
          to: {
            name: "employee-management"
          }
        },
        {
          title: "menu.taskManager",
          htmlBefore: '<i class="material-icons">remove_red_eye</i>',
          permissions: routePermissions["menu.taskManagerView"],
          to: {
            name: "tasks-list"
          }
        },
        {
          title: "menu.managerView",
          permissions: routePermissions["menu.dailyReportManagerView"],
          htmlBefore: '<i class="material-icons">description</i>',
          to: {
            name: "manager-daily-report-card-view"
          }
        },
        {
          title: "menu.attendance.io",
          permissions: routePermissions["menu.attendance.io"],
          htmlBefore: '<i class="material-icons">calendar_today</i>',
          to: {
            name: "attendance-app"
          }
        },
        {
          title: "menu.structure",
          htmlBefore: '<i class="material-icons">view_module</i>',
          permissions: routePermissions.structures,
          to: {
            name: "structures"
          }
        },
        {
          title: "menu.contact",
          htmlBefore: '<i class="material-icons">ring_volume</i>',
          to: {
            name: "contact"
          },
          htmlAfter: ""
        },
        {
          title: "menu.logout",
          htmlBefore: '<i class="material-icons">login</i>',
          htmlAfter: ""
        },
        {
          title: "menu.RGPD",
          htmlBefore: '<i class="fas fa-info"></i>',
          htmlAfter: "",
          to: {
            name: "rgpd"
          }
        }
      ]
    }
  ];
}
